/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ArticleIssue from '../components/ArticleIssue';
import ArticleIssueSection from '../components/ArticleIssueSection';
import ArticlesAllSection from '../components/ArticlesAllSection';
import ArticlesListing from '../components/ArticlesListing';
import ArticlesSection from '../components/ArticlesSection';
import BreadcrumbSection from '../components/BreadcrumbSection';
import Card from '../components/Card';
import Category from '../components/Category';
import ContentBlock from '../components/ContentBlock';
import DevicesRangeListing from '../components/DevicesRangeListing';
import Dropdown from '../components/Dropdown';
import DropdownLink from '../components/DropdownLink';
import Heading from '../components/Heading';
import Hero from '../components/Hero';
import InstructionalContent from '../components/InstructionalContent';
import LayoutSection from '../components/LayoutSection';
import LinkList from '../components/LinkList';
import LoginPage from '../components/LoginPage';
import Modal from '../components/Modal';
import ServiceRequestForm from '../components/ServiceRequestForm';
import Slider from '../components/Slider';
import TabsItem from '../components/TabsItem';
import TabsSection from '../components/TabsSection';
import TabsSectioncopy from '../components/TabsSection copy';
import ThumbnailList from '../components/ThumbnailList';

const components = new Map();
components.set('ArticleIssue', ArticleIssue);
components.set('ArticleIssueSection', ArticleIssueSection);
components.set('ArticlesAllSection', ArticlesAllSection);
components.set('ArticlesListing', ArticlesListing);
components.set('ArticlesSection', ArticlesSection);
components.set('BreadcrumbSection', BreadcrumbSection);
components.set('Card', Card);
components.set('Category', Category);
components.set('ContentBlock', ContentBlock);
components.set('DevicesRangeListing', DevicesRangeListing);
components.set('Dropdown', Dropdown);
components.set('DropdownLink', DropdownLink);
components.set('Heading', Heading);
components.set('Hero', Hero);
components.set('InstructionalContent', InstructionalContent);
components.set('LayoutSection', LayoutSection);
components.set('LinkList', LinkList);
components.set('LoginPage', LoginPage);
components.set('Modal', Modal);
components.set('ServiceRequestForm', ServiceRequestForm);
components.set('Slider', Slider);
components.set('TabsItem', TabsItem);
components.set('TabsSection', TabsSection);
components.set('TabsSection copy', TabsSectioncopy);
components.set('ThumbnailList', ThumbnailList);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
